import styled from 'styled-components';
import { theme } from '@frameio/vapor';

export const STICKY_BUTTON_HEIGHT = 57;

export const StickyItems = styled.div`
  border-top: 1px solid ${theme.colors.border.primary};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: ${STICKY_BUTTON_HEIGHT}px;
  justify-content: center;
  padding: 0 ${theme.spaces[16]};
`;
